import React from 'react';

import PropTypes from 'prop-types';

import PageTitleNew from 'components/ui/PageTitleNew';

import DataTable from 'react-data-table-component';

import { Button } from 'react-bootstrap';
import { Outlet, useNavigate } from 'react-router-dom';

import columns from './columns';

export default function Index({ prompts, refresh }) {
  const navigate = useNavigate();

  const onCreateClick = () => {
    navigate('/admin/prompts/new');
  };

  return (
    <>
      <div className="wrapper_assestment invite_wrapper">
        <PageTitleNew title="Prompts" />

        <div className="text-right">
          <Button
            onClick={onCreateClick}
            bsStyle="primary"
          >
            Add Prompt
          </Button>
        </div>

        <div className="ibox-content mt20">
          <div className="datatable-style">

            <DataTable
              title=""
              columns={columns(refresh)}
              data={prompts || []}
              noDataComponent={(
                <div className="mt20">
                  {prompts == null
                    ? 'Please, wait ...'
                    : 'No matching records found'}
                </div>
          )}
              persistTableHead
              pagination
              paginationComponentOptions={{
                selectAllRowsItem: true,
                selectAllRowsItemText: 'All',
              }}
            />
          </div>
        </div>
      </div>
      <Outlet />
    </>
  );
}

Index.propTypes = {
  prompts: PropTypes.arrayOf(PropTypes.object).isRequired,
  refresh: PropTypes.func.isRequired,
};
